<template>
  <div class="all-question-outer">
    <div class="sign" v-if="questionData.data.is_sign == '1'">
      <img src="../../../../assets/cancelSign.png" alt="" />
      <span>已标记</span>
    </div>
    <div class="question" v-if="questionData.data.content">
      <div class="questionTop">
        <div class="title">
          「判断题」
          <span class="score" v-if="questionData.data.score">{{ questionData.data.score }}分</span>
          <span class="getScore" v-if="questionData.record_id">
            得分:{{
              questionData.data.user_log.score
                ? questionData.data.user_log.score
                : 0
            }}分
          </span>
        </div>
        <!-- 试题附件展示组件 -->
        <question-files v-if="questionData.data.attachment" :attachment="questionData.data.attachment"></question-files>
        <span class="questionName">{{ questionData.data.num }}、<span v-html="questionData.data.content"></span></span>
      </div>
      <ul>
        <a-radio-group v-model="value" disabled>
          <a-radio :style="radioStyle" value="1"> 正确 </a-radio>
          <a-radio :style="radioStyle" value="2"> 错误 </a-radio>
        </a-radio-group>
      </ul>
      <div :class="
          questionData.data.user_log.is_right == '1' ? 'answer1' : 'answer2'
        ">
        <span>正确答案：{{ right }}</span>
        <span>你的答案：{{ myAnswer }}</span>
      </div>
      <div class="ansAnalysis">
        答案解析：
        <div v-html="
            questionData.data.correct_content
              ? questionData.data.correct_content
              : '无'
          "></div>
      </div>
    </div>
    <div class="question" v-else>
      <div class="questionTop">
        <span class="deleted">{{ questionData.data.num }}、此题已被删除</span>
      </div>
      <div class="deleteImg">
        <img src="@/assets/deleted.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import QuestionFiles from "../questionFiles.vue";
export default {
  name: "judge",
  props: ["questionData"],
  components: { QuestionFiles },
  data () {
    return {
      value: this.questionData.data.user_log
        ? this.questionData.data.user_log.answer
        : "",
      right: null,
      myAnswer: null,
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
    };
  },
  mounted () {
    if (this.questionData.data && this.questionData.data.items && this.questionData.data.items[0].is_right == "1") {
      this.right = "正确";
    } else {
      this.right = "错误";
    }
    if (this.questionData.data && this.questionData.data.user_log) {
      if (this.questionData.data.user_log.answer == "1") {
        this.myAnswer = "正确";
      } else if (this.questionData.data.user_log.answer == "2") {
        this.myAnswer = "错误";
      } else {
        this.myAnswer = "无";
      }
    }
  },
};
</script>

<style lang="less" scoped>
.all-question-outer {
  width: 100%;
  height: calc(100% - 60px);
  padding: 20px 50px 30px 50px;
  position: relative;
}
.sign {
  height: 32px;
  text-align: right;
  color: #f79e3f;
  position: absolute;
  top: 35px;
  right: 50px;
}
.sign img {
  width: 30px;
  height: auto;
  margin-right: 4px;
  display: inline-block;
}
.sign span {
  line-height: 32px;
}
.question .title {
  width: 371px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 32px;
}
.question .questionName {
  width: 92px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #14202c;
  line-height: 32px;
  word-wrap: break-word;
  word-break: normal;
}
.questionTop {
  padding: 15px 0 0;
  /deep/img {
    display: block;
    max-width: 100%;
  }
  /deep/p:first-child {
    display: inline;
  }
  /deep/ol {
    list-style: decimal;
  }
}
li {
  margin-bottom: 10px;
}
.answer1 {
  height: 40px;
  background: #d7f3ea;
  margin-top: 15px;
  /deep/img {
    display: block;
    max-width: 100% !important;
  }
}
.answer2 {
  height: 40px;
  background: #fae7e6;
  margin-top: 15px;
  /deep/img {
    display: block;
    max-width: 100% !important;
  }
}
.answer1 span {
  width: 79px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #32b387;
  line-height: 40px;
  margin-left: 18px;
  margin-right: 10px;
}
.answer2 span {
  width: 79px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ea7e7b;
  line-height: 40px;
  margin-left: 18px;
  margin-right: 10px;
}
.ansAnalysis {
  margin-top: 21px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
  word-break: break-all;
  margin-bottom: 40px;
  /deep/img {
    display: block;
    max-width: 100% !important;
  }
}
/deep/p {
  display: inline;
}
/deep/.ansAnalysis img {
  max-width: 90% !important;
  display: block;
}
.score {
  color: #9a3bec;
  font-weight: normal;
}
.deleted {
  color: #ea7e7b;
  font-size: 16px;
}
.deleteImg {
  text-align: center;
  height: 475px;
  margin-top: 140px;
}
.getScore {
  margin-left: 50px;
  font-weight: normal;
}
</style>